module.exports = __webpack_public_path__ + "img/login.6b566d21.svg";